import useStorage from './storage/useStorage';
import useRxConditionId from './useRxConditionId';

/**
 * Hook to get and set the rxId, which is stored in the conditionId as key in ostro's storage engine.
 * This hook is needed for local development only and should not be used in production.
 * @returns {string} rxId
 */
export default function useRxId() {
  const [conditionId] = useRxConditionId();
  return useStorage(conditionId, '');
}
